<template>
  <font-awesome-icon
    icon="money-check"
    size="lg"
    class="icon"
    @click.stop="editBank()"/>
</template>

<script>
export default {
  props: {
    user: {
      required: true,
      type: Object
    }
  },

  methods: {
    editBank: function () {
      this.$router.push({
        name: 'user-bank-edit',
        params: { id: this.user.id }
      })
    }
  }
}
</script>
